<template>
	<v-app>
		<link rel='icon' href='../public/iconPage__.ico' />
		<!-- <knd-error-dialog></knd-error-dialog> -->
		<knd-error-notify></knd-error-notify>
		<knd-success-notify></knd-success-notify>
		<div id='app' style="height:100%">
			<router-view />
		</div>
	</v-app>
</template>

<script>
import kndErrorNotify from './components/kndErrorNotify.vue'
import kndSuccessNotify from './components/kndSuccessNotify.vue'

export default {
    name: 'app',

    components: {
		kndErrorNotify,
		kndSuccessNotify
    },
	mounted(){
		this.$store.dispatch('interceptor/intercept')
	}
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
</style>
